<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div v-if="permission.access">
    <div class="row">
      <div class="col-md-8">
        <b-card no-body>
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->
                <v-select
                  @on-change="paginateChange"
                  :options="perPageOptions"
                  v-model="search.paginate"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="search.search_data"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">Sl</th>
                  <th>Title</th>
                  <th class="text-center">Status</th>
                  <th class="text-center" v-if="permission.edit">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(department, index) in success_stories.data"
                  :key="index"
                  v-if="success_stories.data.length"
                >
                  <td class="align-middle text-center">
                    {{ success_stories.from + index }}
                  </td>
                  <td>
                    <p class="mb-0">
                      <b>
                        {{ department.title }}
                      </b>
                    </p>
                  </td>
                  <td class="align-middle text-center">
                    <span
                      class="badge"
                      :class="
                        department.status == 1
                          ? 'badge-success'
                          : 'badge-danger'
                      "
                    >
                      {{ department.status == 1 ? "Active" : "Inactive" }}
                    </span>
                  </td>
                  <td class="align-middle text-center" v-if="permission.edit">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="edit(department.id)"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >Showing
                  {{ success_stories.from ? success_stories.from : 0 }} to
                  {{ success_stories.to ? success_stories.to : 0 }} of
                  {{ success_stories.total ? success_stories.total : 0 }}
                  entries</span
                >
              </b-col>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <pagination
                  :data="success_stories"
                  @pagination-change-page="getResults"
                  align="right"
                  :show-disabled="true"
                  :limit="5"
                ></pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
      <div class="col-md-4" v-if="permission.create || form.id != ''">
        <b-card :title="(form.id == '' ? 'Create' : 'Update') + ' Department'">
          <b-card-text
            ><validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
                enctype="multipart/form-data"
              >
                <b-form-group label="Select Category" label-for="category_id">
                  <validation-provider
                    #default="{ errors }"
                    name="category_id"
                    rules="required"
                  >
                    <v-select
                      id="category_id"
                      v-model="form.category_id"
                      placeholder="Select Category"
                      multiple
                      :options="success_story_categories"
                      label="name"
                      :reduce="(option) => option.id"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div class="row">
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Title" label-for="title">
                      <validation-provider
                        #default="{ errors }"
                        name="title"
                        rules="required"
                      >
                        <b-form-input
                          id="title"
                          v-model="form.title"
                          :state="errors.length > 0 ? false : null"
                          name="title"
                          placeholder="Enter Your Title"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Video ID" label-for="video_id">
                      <validation-provider
                        #default="{ errors }"
                        name="video_id"
                        rules="required"
                      >
                        <b-form-input
                          id="video_id"
                          v-model="form.video_id"
                          :state="errors.length > 0 ? false : null"
                          name="video_id"
                          placeholder="Enter Your Video ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <div class="border rounded p-2 mb-2">
                      <b-media no-body vertical-align="center">
                        <b-media-aside>
                          <b-img
                            :src="video_thumbnail"
                            height="174"
                            width="310"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                      </b-media>
                      <b-media-body class="mt-2">
                        <b-form-file
                          id="video_thumbnail"
                          accept=".jpg, .png, .gif"
                          @change="loadImage($event)"
                          placeholder="Select Video Thumbnail"
                          drop-placeholder="Drop file here..."
                        />
                      </b-media-body>
                    </div>
                  </div>
                </div>
                <!-- submit buttons -->
                <b-form-checkbox
                  name="status"
                  style="margin-top: 5px"
                  v-model="form.status"
                  switch
                  inline
                >
                </b-form-checkbox>
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  @click="validationForm"
                >
                  {{ form.id == "" ? "Create" : "Update" }}
                </b-button>
                <b-button
                  type="submit"
                  class="float-right mx-1"
                  variant="outline-primary"
                  @click="Close"
                >
                  Close
                </b-button>
              </b-form>
            </validation-observer></b-card-text
          >
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  data() {
    return {
      search: {
        search_data: "",
        paginate: 10,
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100],
      form: {
        id: "",
        title: "",
        video_id: "",
        status: true,
        video_thumbnail: "",
        category_id: [],
      },
      video_thumbnail: this.$store.state.base_url + "images/course/default.png",
      success_stories: {},
      permission: {
        access: false,
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResults();
    this.$store.dispatch("getSuccessStoryCategory");
    this.Permission();
  },
  methods: {
    async getResults(page) {
      this.search.page = page == null ? this.search.page : page;
      const success_stories = await this.callApi(
        "post",
        "/app/success/story?page=" + this.search.page,
        this.search
      );
      if (success_stories.status == 200) {
        this.success_stories = success_stories.data.success_stories;
      }
    },

    loadImage(e) {
      this.form.video_thumbnail = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.video_thumbnail = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Close() {
      this.form.id = "";
      this.form.title = "";
      this.form.video_id = "";
      this.form.status = true;
      this.form.video_thumbnail = "";
      this.form.category_id = [];
      this.video_thumbnail =
        this.$store.state.base_url + "images/course/default.png";
    },

    async edit(id) {
      const success_story = await this.callApi(
        "post",
        "/app/success/story/show/" + id
      );
      if (success_story.status == 200) {
        this.form.id = success_story.data.success_story.id;
        this.form.title = success_story.data.success_story.title;
        this.form.video_id = success_story.data.success_story.video_id;
        success_story.data.success_story.categories.forEach((category) => {
          this.form.category_id.push(category.id);
        });
        this.form.status =
          success_story.data.success_story.status == true ? true : false;
        this.video_thumbnail =
          this.$store.state.base_url +
          success_story.data.success_story.video_thumbnail;
      }
    },

    add() {
      const fd = new FormData();
      if (this.form.video_thumbnail) {
        fd.append(
          "video_thumbnail",
          this.form.video_thumbnail,
          this.form.video_thumbnail.name
        );
      }

      for (let i = 0; i < this.form.category_id.length; i++) {
        let category_id = this.form.category_id[i];
        fd.append("category_id[" + i + "]", category_id);
      }

      fd.append("id", this.form.id);
      fd.append("title", this.form.title);
      fd.append("video_id", this.form.video_id);
      fd.append("status", this.form.status);

      axios
        .post("/app/success/story/add", fd)
        .then((res) => {
          this.getResults();
          this.Close();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.title)
              this.e(e.response.data.errors.title[0]);
            if (e.response.data.errors.video_id)
              this.e(e.response.data.errors.video_id[0]);
            if (e.response.data.errors.category_id)
              this.e(e.response.data.errors.category_id[0]);
          }
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.add();
        }
      });
    },

    SearchData: _.debounce(function () {
      this.search.page = 1;
      this.getResults();
    }, 1000),

    // Paginate Data Gate
    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "success.story.access") {
          this.permission.access = true;
        }

        if (permission.slug == "success.story.create") {
          this.permission.create = true;
        }

        if (permission.slug == "success.story.edit") {
          this.permission.edit = true;
        }

        if (permission.slug == "success.story.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  watch: {
    "search.search_data": function (val) {
      this.SearchData();
    },
    "search.paginate": function (val) {
      this.paginateChange();
    },
  },
  computed: {
    success_story_categories() {
      return this.$store.getters.getSuccessStoryCategory;
    },
  },
  components: {
    vSelect,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
};
</script>

<style></style>
